export class CMSContentConfigModel {
  colour_content: {[key:string] : string}
  image_content: {[key:string] : string}
  seo_content: {[key:string] : { title: string, description: string, keywords: string }}
  text_content: {[key:string] : string}
}
